import React from 'react';

import { IBubbleData } from '../../../../../interfaces/charts';
import { toLocaleNumberFormat } from '../../../../../utils/utils';
import './BubblesChartContentExpanded.scss';

interface IBubblesChartExpanded {
  expandedData: IBubbleData[] | undefined;
  child: React.ReactNode;
}

const BubblesChartContentExpanded = ({ expandedData, child }: IBubblesChartExpanded) => {
  const maxDiameter = 74;
  const minDiameter = 24;
  const step = 20;

  if (!expandedData) return null;

  return (
    <div className={`expandable-content flex flex-row items-center lenght-${expandedData.length}`}>
      <div className="expandable-content-inner flex flex-row items-center ">
        {expandedData.map((item, index) => {
          const diameter = Math.max(maxDiameter - index * step, minDiameter);
          const isUpwards = index % 2 === 0;
          const isLast = index === expandedData.length - 1;
          const flexDirection = isUpwards ? 'column-reverse' : 'column';
          let lineHeight;
          let bottomStyle;

          if (index === 0) {
            lineHeight = '28px';
          } else if (index === 1) {
            lineHeight = '40px';
          } else if (index === 2) {
            lineHeight = '42px';
          } else {
            lineHeight = '45px';
          }

          if (index === 0 || index === 2) {
            bottomStyle = '90%';
          } else if (index === 1) {
            bottomStyle = item.name.length > 14 ? '-180%' : '-143%';
          } else if (isLast) {
            bottomStyle = '-380%';
          }
          const marginStyle = isUpwards ? { marginBottom: '6px' } : { marginTop: '6px' };

          return (
            <div key={item.name} className="bc-item">
              <div className="other-bubble-chart" style={{ width: `${diameter}px`, height: `${diameter}px` }}>
                <div
                  className="connector-content flex items-center justify-end"
                  style={{
                    bottom: bottomStyle,
                    flexDirection: flexDirection
                  }}
                >
                  <div className="line" style={{ height: lineHeight }} />
                  <div className="text-information flex flex-column items-center" style={{ ...marginStyle }}>
                    <span className="label">{item.name}</span>
                    <span className="number">{toLocaleNumberFormat(item.value)}%</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {child}
      </div>
    </div>
  );
};

export default BubblesChartContentExpanded;
